export const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP'

export const updateCurrentAppStep = step => ({
  type: UPDATE_CURRENT_STEP,
  payload: step,
})